<script setup lang="ts">
import { ArrowUpTrayIcon, ExclamationTriangleIcon } from "@heroicons/vue/24/outline"
import { useUploadDialogState } from "./uploadDialogState"

defineProps<{
  activeCount: number
  dirtyCount: number
  errorCount: number
}>()

const state = useUploadDialogState()
</script>

<template>
  <button
    type="button"
    class="btn btn-ghost btn-sm gap-1.5 relative"
    aria-label="Upload"
    @click="state.open()"
  >
    <ArrowUpTrayIcon class="w-5 h-5"/>
    <span class="hidden lg:inline">Upload</span>

    <span
      v-if="errorCount > 0"
      data-testid="badge-error"
      class="absolute -top-1 -right-1 bg-red-500 text-white w-4 h-4 rounded-full flex items-center justify-center"
    >
      <ExclamationTriangleIcon class="w-3 h-3"/>
    </span>
    <span
      v-else-if="activeCount > 0"
      data-testid="badge-active"
      class="absolute -top-1 -right-1 bg-cyan-500 text-white text-xs font-bold min-w-4 h-4 px-1 rounded-full flex items-center justify-center"
    >
      {{ activeCount }}
    </span>
    <span
      v-else-if="dirtyCount > 0"
      data-testid="badge-dirty"
      class="absolute -top-1 -right-1 w-3 h-3 bg-amber-500 rounded-full"
    />
  </button>
</template>
